import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutlineOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import type { ComponentType } from "react";

/**
 * The navigation table.
 *
 * Pure data: labels are i18n *keys* resolved by the consumer, never resolved strings,
 * so the same table serves the tab bar, the side rail and any future menu without one
 * of them drifting out of sync.
 */
export interface NavItem {
  /** i18n key for the label. Resolve with `t()` at the call site. */
  labelKey: string;
  path: string;
  icon: ComponentType<SvgIconProps>;
}

export const NAV_ITEMS: NavItem[] = [
  // The dashboard lives at /news because the feed is what it currently holds, and
  // articles nest under it as /news/:slug. Only the label says "Dashboard". The
  // dashboard's round calendar button is a shortcut into the Events tab.
  { labelKey: "nav.dashboard", path: "/news", icon: ArticleOutlinedIcon },
  { labelKey: "nav.events", path: "/events", icon: CalendarMonthOutlinedIcon },
  { labelKey: "nav.protocols", path: "/protocols", icon: ScienceOutlinedIcon },
  { labelKey: "nav.profile", path: "/profile", icon: PersonOutlineIcon },
];

/**
 * Whether a tab should render as selected.
 *
 * Prefix matching, so an article detail (`/news/rytmus`) keeps the dashboard tab lit.
 */
export function isActive(path: string, pathname: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}

/** The nav item owning a pathname, if any. */
export function itemForPath(pathname: string): NavItem | undefined {
  return NAV_ITEMS.find((item) => isActive(item.path, pathname));
}
